module.exports = __webpack_public_path__ + "static/ivan_puzak-03d63ccfbd84b33c6b6f166fee3c8f95.png";